import { apiSlice } from "../../../../services";
import { s3ApiSlice } from "../../../../services/api/s3ApiSlice";
import { IKioskSettingReq, IKioskSettingRes, IUpdateKioskReq, IUploadFileParams, IUploadFileRes } from "../../types";
import { S3_ENDPOINT_MAP } from "../constants";
import { ensureSupportedKioskLanguageCodes } from "../utils/languageOptions";
import { validateFileSize } from "../utils/validateFileSize";

export const kioskApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // ==================== Kiosk 設定 (update, get) ====================
        updateKioskSetting: builder.mutation<IKioskSettingRes, IUpdateKioskReq>({
            query: (reqData) => ({
                url: "/character/update_kiosk_setting",
                method: "POST",
                body: { ...reqData },
            }),
            invalidatesTags: ["kioskSetting"],
        }),

        getKioskSetting: builder.query<IKioskSettingRes, IKioskSettingReq>({
            query: (reqData) => ({
                url: "/character/kiosk_setting",
                method: "GET",
                params: { ...reqData },
            }),
            providesTags: ["kioskSetting"],
        }),

        // ==================== 上傳資產檔案 (upload, delete) ====================
        uploadFile: builder.mutation<IUploadFileRes, IUploadFileParams>({
            query: ({ file, prefix }) => {
                validateFileSize(file, prefix);

                const formData = new FormData();
                formData.append("file", file);

                return {
                    url: `/assets/upload?prefix=${prefix}`,
                    method: "POST",
                    body: formData,
                };
            },
        }),

        // 刪除資產
        deleteAsset: builder.mutation<{ success: boolean }, string>({
            query: (asset_id) => ({
                url: `/assets/${asset_id}`,
                method: "DELETE",
            }),
        }),
    }),
    overrideExisting: false,
});

// ==================== Kiosk 語言取得 (接S3 Endpoint) ====================
export const kioskLanguageApiSlice = s3ApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getKioskLanguage: builder.query<string[], void>({
            query: () => ({
                url: S3_ENDPOINT_MAP.GET_KIOSK_LANGUAGE,
            }),
            providesTags: ["kioskLanguage"],
            transformResponse: (response: { name: string; code: string }[]) => {
                return ensureSupportedKioskLanguageCodes(response.map((option) => option.code));
            },
        }),
    }),
    overrideExisting: false,
});

export const { useUpdateKioskSettingMutation, useGetKioskSettingQuery, useUploadFileMutation, useDeleteAssetMutation } =
    kioskApiSlice;

export const { useGetKioskLanguageQuery } = kioskLanguageApiSlice;
